module.exports = __webpack_public_path__ + "static/img/ic_tools.b7edc29.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ic_tools.png
// module id = FSmE
// module chunks = 1